export function toTitleCase(name: string): string {
  return name
    .toLowerCase()
    .split(/[\s_]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function containsEmoji(description: string): boolean {
  if (!description) return false;

  const emojiRegex = /[\p{Emoji_Presentation}\uFE0F]/u;
  return emojiRegex.test(description);
}

export const getStrippedText = (html : string) => {
  return html
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ') 
    .replace(/\s+/g, '')
    .trim();
};
